import React, {PropTypes} from 'react';
import {Tooltip} from 'routes/app/components';
import './style.scss';

const Barometer = ({level, max, translate}) => {

    let blocks = [];
    for (let i = 1; i <= max; i++) {
        let className = i <= level ? `tsp-barometer-block full lvl${level}` : `tsp-barometer-block lvl${level}`;
        blocks.push(<div key={i} className={className} />);
    }

    return (
        <Tooltip className="tsp-barometer" text={translate({id: 'timeslotpicker.modal.history.' + level})}>
            {blocks}
        </Tooltip>
    );
};

Barometer.propTypes = {
    level: PropTypes.number,
    max: PropTypes.number,
    translate: PropTypes.func
};

Barometer.defaultProps = {
    max: 5
};

export default Barometer;
